export default {
  navigationBarTitleText: '预约拍摄'
};
